import React from 'react'
import logoSVG from '../assets/logo.svg'

// The previous version logged "Logo loaded successfully" on every successful render and
// "Logo failed to load" on every error. The success log fired thousands of times per session
// for no reason; the error log was kept (the only useful signal) but only in non-production.
const Logo = ({ w, h }) => {
  const handleError = () => {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Logo failed to load:', logoSVG)
    }
  }

  return (
    <img
      src={logoSVG}
      alt="UrbanAI Logo"
      width={w || 180}
      height={h || 50}
      style={{
        maxWidth: '100%',
        height: 'auto',
        objectFit: 'contain',
        display: 'block',
      }}
      onError={handleError}
    />
  )
}

export default Logo;
